import { Button, Group, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import TRACKING_IDS from 'tracking-ids';

import type { ReactNode } from 'react';

type RecoveryRequestsMessageProps = {
  count: number;
  onReview: () => void;
};

/**
 * Body of the notice that RecoveryRequestsNotifier shows: how many requests wait for approval
 * and a button to review them.
 */
export function RecoveryRequestsMessage({
  count,
  onReview,
}: RecoveryRequestsMessageProps): ReactNode {
  const { t } = useTranslation(['Session']);

  return (
    <Stack gap="sm">
      <Text size="sm">{t('Session:recoveryRequests.message', { count })}</Text>
      <Group justify="flex-end">
        <Button
          size="xs"
          variant="light"
          onClick={onReview}
          data-tracking-id={TRACKING_IDS.hatch.recoveryRequests.review}
        >
          {t('Session:recoveryRequests.link')}
        </Button>
      </Group>
    </Stack>
  );
}
